import { useState } from "react";
import { apiErrorCode } from "@/api/client";
import { Button, Card, Input } from "@/components/ui/primitives";
import { useAuth } from "@/hooks/use-auth";
import { useI18n } from "@/i18n";

export function LoginPage() {
  const { signIn } = useAuth();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (caught) {
      // A missing response means the server is unreachable, which is a very
      // different problem from a wrong password.
      const code = apiErrorCode(caught);
      setError(code ? t("signInFailed") : t("networkError"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-sm p-6">
        <div className="mb-6 text-center">
          <h1 className="text-xl font-bold tracking-tight">{t("appName")}</h1>
          <p className="text-sm text-muted-foreground">{t("panelName")}</p>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1">
            <label htmlFor="email" className="text-sm font-medium">
              {t("email")}
            </label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>

          <div className="space-y-1">
            <label htmlFor="password" className="text-sm font-medium">
              {t("password")}
            </label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          {error && <p className="text-sm text-destructive">{error}</p>}

          <Button type="submit" className="w-full" disabled={busy}>
            {t("signIn")}
          </Button>

          <a
            href="/reset"
            className="block text-center text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            Şifremi unuttum
          </a>
        </form>
      </Card>
    </div>
  );
}
